











































import { Component, Prop, Vue } from "vue-property-decorator";
import { CartItem, Book, LooseObject } from "./types";
import axios from "axios";
import Search from "@/components/Search.vue";
import Bottom from "@/components/Bottom.vue";
import { mobile } from "./Mixins/isMobile";
import { State, Getter } from "vuex-class";

//import { store } from './store'
@Component({
  components: { Search, Bottom },
  mixins: [mobile]
})
export default class App extends Vue {
  //  books!: Array<Book>;
  //  @State books!: Array<Book>;
  @Getter cartCounter!: number;
  public $refs!: {
    cart: HTMLElement;
    searchfield: any;
  };
  baseSize: LooseObject = {
    fontSize: this.calculateBaseSize() + "px"
  };
  @Getter issearching!: boolean;

  timer!: number;
  beforeMount() {
    const server: string = this.$store.state.dev ? "http://localhost:8888" : "";

    if (this.$store.state.admin) {
      axios
        .get(server + "/backend/functions/function.init.php")
        .then(response => this.$store.commit("setData", response.data));
      axios
        .get(server + "/backend/functions/function.getIsbn.php")
        .then(response => this.$store.commit("setIsbn", response.data));
      axios
        .get(server + "/backend/functions/function.getAuthors.php")
        .then(response => this.$store.commit("setAuthors", response.data));
      axios
        .get(server + "/backend/functions/function.getKeywords.php")
        .then(response => this.$store.commit("setKeywords", response.data));
    } else {
      axios
        .get(server + "/get/apropos.json")
        .then(response => this.$store.commit("setData", response.data));
      //TODO: wieder einfügen
      axios
        .get(server + "/backend/functions/function.init.php")
        .then(response => this.$store.commit("setData", response.data));
    }
  }
  mounted() {
    window.addEventListener("resize", this.changeBaseSize);
    this.changeBaseSize();
  }
  get logo() {
    if (this.$store.state.width < 450) {
      return "apropos_logo_small.svg";
    }
    if (this.issearching && this.$store.state.width < 575) {
      return "apropos_logo_small.svg";
    }
    return this.$store.state.width > 900 || this.$store.state.width < 700
      ? "apropos_logo.svg"
      : "apropos_logo_small.svg";
    //  return "apropos_logo.svg";
  }

  get cartCount() {
    if (this.$refs.cart) {
      this.highlightCart();
    } else {
      setTimeout(this.highlightCart, 50);
    }
    return this.cartCounter;
  }
  highlightCart() {
    if (this.cartCounter > 0) {
      this.$refs.cart.classList.add("highlite");
      clearTimeout(this.timer);
      this.timer = setTimeout(this.removeHiglight, 2000);
    }
  }
  removeHiglight() {
    this.$refs.cart.classList.remove("highlite");
  }
  search() {
    this.$store.commit("searching", true);
    //  this.$refs.searchfield.focus();
    //  console.log(this.$refs.searchfield);
  }
  calculateBaseSize() {
    if (window.innerWidth === 1440) {
      return 9;
    } else {
      return window.innerWidth >= 990
        ? (window.innerWidth - (window.innerWidth - 1440) * 0.75) * 0.00625
        : 8.3;
    }
  }
  changeBaseSize() {
    this.$store.commit("setWindowSize", window.innerWidth);
    this.baseSize.fontSize = this.calculateBaseSize() + "px";
  }
  updateSearch(value: string) {
    this.$store.commit("updateSearch", value.toLowerCase());
  }
}
